module.exports = __webpack_public_path__ + "static/img/img01.785de8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/en/en001/sp/img01.jpg
// module id = w8tU
// module chunks = 0